/**
 * Each imported quota's review details, from the import that created it: the import job's id (the
 * skip question's answer is kept per job), its count_check (null from v1.5.0: not checked), its
 * AND / OR counts when it needs a choice, and its skip flag. Imports skip quotas already imported,
 * so a quota is in one import's `imported`; a later import never replaces or clears its details.
 * `jobs` are finished import jobs, in any order.
 */
const reviewByQuota = (jobs) => {
  const details = new Map();
  jobs.forEach((job) => {
    const result = job.progress?.result;
    if (!result) return;
    const needsChoice = new Map((result.needs_join_choice || []).map((q) => [q.quota_id, q]));
    const skippable = new Map((result.skippable_not_in || []).map((q) => [q.quota_id, q]));
    (result.imported || []).forEach((q) => {
      if (details.has(q.quota_id)) return;
      details.set(q.quota_id, {
        jobId: job.id,
        countCheck: q.count_check,
        joinChoice: needsChoice.get(q.quota_id)?.count_check,
        skipFlag: skippable.get(q.quota_id),
      });
    });
  });
  return details;
};

export default reviewByQuota;
